import { useState, useCallback, useRef, useEffect } from "react";
import type { ToastVariant } from "../components/Toast";

interface ToastState {
  message: string;
  visible: boolean;
  variant: ToastVariant;
}

export function useToast(duration = 3000) {
  const [toast, setToast] = useState<ToastState>({ message: "", visible: false, variant: "success" });
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const showToast = useCallback(
    (message: string, variant: ToastVariant = "success") => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setToast({ message, visible: true, variant });
      timerRef.current = setTimeout(() => setToast({ message: "", visible: false, variant: "success" }), duration);
    },
    [duration],
  );

  return { toast, showToast };
}
